import useModuleInfo from "./useModuleInfo";
import useSubscription from "./useSubscription";
import { PlanFeatures } from "../util/constants";

const noop = async () => {};

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

const hasAnySharedLimitOverage = (sharedLimits = {}) =>
  Object.values(sharedLimits || {}).some(
    (entry) => toNumber(entry?.overLimits) > 0,
  );

const isUsersOverLimit = (addon = {}) => {
  const isUnlimited = Boolean(addon?.isUnlimitedUsersLimit);
  if (isUnlimited) return false;

  const totalUsed = toNumber(addon?.totalUsed ?? addon?.overages);
  const totalUsersLimit = toNumber(
    addon?.totalUsersLimit ||
      addon?.planLimit ||
      toNumber(addon?.totalIncludedUsers) +
        toNumber(addon?.totalPurchasedUsers),
  );

  if (totalUsersLimit > 0) {
    return totalUsed > totalUsersLimit;
  }

  return toNumber(addon?.overLimits) > 0;
};

const isAddonOverLimit = (feature, addon = {}) => {
  if (feature === PlanFeatures.TEMPLATES) {
    return hasAnySharedLimitOverage(addon?.sharedLimits);
  }

  if (feature === PlanFeatures.USERS) {
    return isUsersOverLimit(addon);
  }

  return toNumber(addon?.overLimits) > 0;
};

export default function useBeAbleToStartChase(
  moduleName = "receivables-module",
) {
  const { plan } = useModuleInfo(moduleName);

  const {
    invoicesChasedThisMonth,
    refetchSubscriptionData,
    subscription: {
      isBundle,
      subscriptionService,
      moduleSubscriptions: subscribedModules,
    },
  } = useSubscription();

  const matchedModule = (subscribedModules || []).find((module) => {
    const normalizedModuleId = String(module?.id || "").toLowerCase();
    return normalizedModuleId === moduleName;
  });

  const hasReceivablesModule = Boolean(matchedModule);
  const isModuleInTrial = Boolean(matchedModule?.isInTrial);

  const isReceivablesSubscription =
    !Array.isArray(subscribedModules) ||
    subscribedModules.length === 0 ||
    hasReceivablesModule;

  const canStartChase = !isReceivablesSubscription
    ? true
    : Object.entries(plan?.addons || {}).every(
        ([feature, addon]) => !isAddonOverLimit(feature, addon),
      );

  return {
    canStartChase: canStartChase,
    invoicesChasedThisMonth,
    plan: plan || {},
    isBundle,
    isInTrial: isModuleInTrial,
    subscriptionService,
    refetchSubscriptionData: canStartChase ? noop : refetchSubscriptionData,
  };
}
